import { conciergeApiDef } from "@kosmod/concierge";
import { HttpApi } from "@kosmod/pancake";
import { loginAPI, gamesAPI } from "@kosmod/sesame";
import { theatreAPI } from "@kosmod/theatre";
import { assetsAPI } from '@kosmod/assets';

export const kosmodAPI = HttpApi.Root({
  'scene': theatreAPI,
  'session': conciergeApiDef,
  'login': loginAPI,
  'games': gamesAPI,
  'assets': assetsAPI
})
export type KosmodURLs = HttpApi.URLMap<typeof kosmodAPI>;
export type KosmodAPIClient = HttpApi.Handler<"client", typeof kosmodAPI>;
